var _style, _polygon, _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polyline, _polyline2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFarm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "31,17 21,17 21,11 28,11 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7,
    cy: 24,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 26,
    cy: 24,
    r: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    className: "st0",
    width: 5,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    className: "st0",
    width: 5,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    className: "st0",
    width: 5,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    className: "st0",
    width: 5,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    className: "st0",
    width: 5,
    height: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    className: "st0",
    width: 5,
    height: 4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "9.8,23 21,23 21,17 1,17 1,23 4.2,23 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "23.2,23 21,23 21,17 31,17 31,23 28.8,23 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/farm.d8f9ff00fec027042a4be8327230c977.svg";
export { ForwardRef as ReactComponent };